import styled from "styled-components";
import { isMobile, isTablet, isDesktop } from "react-device-detect";

export const StatusMessage = styled.div`
  background-color: #f0f0f0;
  width: 100%;
  padding: ${isMobile ? "5px" : isTablet ? "10px" : "10px"};
  color: ${({ packed }) => (packed ? "grey" : "orange")};
  font-size: ${isMobile ? "10px" : "14px"};
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0px;
  right: 0px;
  text-align: center;

  p {
    margin: 0;
    padding: 0;
    display: inline;
  }

  i {
    margin-right: 5px;
    padding: 0;
  }
`;

export const PackageStatusMessage = styled.div`
  background-color: #f0f0f0;
  width: 100%;
  padding: 10px;
  color: grey;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0px;
  right: 0px;
  text-align: center;

  & > span {
    margin-right: 8px;
  }
`;

export const LabelSquare = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 0;
  margin: 0;
  text-align: center;
  line-height: 20px;
  font-size: 10px;
  background-color: #f9f9f9;
`;

export const OrderItem = styled.div`
  padding: ${isMobile ? "10px" : "20px"};
  margin: ${isMobile ? "10px" : "10px"};
  border-radius: ${isMobile ? "2px" : isTablet ? "4px" : "4px"};
  width: ${isMobile ? "40%" : isTablet ? "35%" : "22%"};
  cursor: pointer;
  border: 1px solid #ddd;
  background-color: ${(props) => (props.completed ? "#f9f9f9" : "#ffffff")};
  text-align: center;

  &:hover {
    background-color: #f0f0f0;
  }
`;

export const PartItem = styled.div`
  padding: ${isMobile ? "10px" : "20px"};
  margin: ${isMobile ? "15px" : "15px"};
  border-radius: ${isMobile ? "2px" : isTablet ? "4px" : "4px"};
  width: ${isMobile ? "40%" : isTablet ? "35%" : "22%"};
  background-color: ${(props) => (props.completed ? "#f9f9f9" : "#ffffff")};
  cursor: pointer;
  position: relative;
  border: ${({ selected }) =>
    selected ? "2px solid lightblue" : "1px solid #ddd"};
  text-align: center;

  &:hover {
    background-color: #f0f0f0;
  }

  /* Checkbox style */
  & input[type="checkbox"] {
    position: absolute;
    left: ${isMobile ? "15px" : "10px"};
    top: ${isMobile ? "15px" : "10px"};
    transform: ${isMobile ? "scale(2.5)" : "scale(1.5)"};
    cursor: pointer;
  }

  /* Panel text */
  &::after {
    content: "${(props) => props.partType || "Panel"}";
    position: absolute;
    right: 0px;
    top: 0px;
    font-size: 10px;
    color: grey;
    background-color: #f0f0f0;
    padding: 2px 5px;
    border-radius: 3px;
  }
  & ${StatusMessage} {
    position: absolute;
    bottom: 0;
    width: 100%;
    margin-top: 0;
  }
`;

export const PartsList = styled.div`
  overflow-y: auto;
  margin: 0px;
  padding-bottom: ${(props) =>
    props.selectedPartsCount > 0 ? "100px" : "0px"};
  display: flex;
  flex-wrap: wrap;
  justify-content: ${isMobile ? "center" : "space-between"};
  align-items: ${isMobile ? "flex-start" : "center"};
`;

export const OrderList = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  padding: ${isMobile ? "5px" : "10px"};
  justify-content: space-evenly;
  align-items: center;
`;

export const FilterButton = styled.button`
  background-color: ${(props) => (props.active ? "navy" : "white")};
  color: ${(props) => (props.active ? "white" : "navy")};
  border: 2px solid navy;
  padding: 10px 20px;
  margin: 0;
  border-radius: ${(props) => (props.active ? "4px 4px 0 0" : "4px")};
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  outline: none;

  &:first-child {
    border-radius: 4px 0 0 4px;
  }

  &:last-child {
    border-radius: 0 4px 4px 0;
  }

  &:hover {
    background-color: ${(props) => (props.active ? "navy" : "#e0e0e0")};
  }
`;

export const OrderID = styled.div`
  font-size: ${isMobile ? "10px" : "14px"};
  color: black;
`;

export const ProjectName = styled.div`
  font-size: ${isMobile ? "10px" : "14px"};
`;

export const SourcingLabel = styled.h3`
  font-size: ${isMobile ? "30px" : "24px"};
  color: black;
`;
export const PartName = styled.p`
  color: grey;
  padding-bottom: ${isMobile ? "5px" : "5px"};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 0;
`;

export const TabContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-bottom: 3px solid grey;
`;

export const TabButton = styled.button`
  background: ${({ active }) => (active ? "grey" : "transparent")};
  color: ${({ active }) => (active ? "white" : "grey")};
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  cursor: pointer;
  font-weight: ${({ active }) => (active ? "bold" : "normal")};

  &:last-child {
    margin-right: 0;
  }
`;

export const ContentContainer = styled.div`
  margin-top: 20px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

export const ToggleButton = styled.button`
  background: ${({ active }) => (active ? "#356e8f" : "#328da8")};
  color: white;
  border: 1px solid transparent;
  padding: 10px;
  margin-right: 0;
  border-radius: 0;
  cursor: pointer;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const CountCircle = styled.div`
  font-size: ${isMobile ? "12px" : "12px"};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: white;
  color: black;
  border: 1px solid #ddd;
  margin-left: 5px;
`;

export const Notifications = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #2db1ec;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  width: 100%;
  height: 12%;
`;

export const NotificationsText = styled.h6`
  margin: 0;
  padding: 20px;
  color: white;
`;

export const NotificationsButton = styled.button`
  background-color: black;
  color: white;
  border: none;
  padding: 7px 20px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;

  &:hover {
    background-color: var(--bs-primary);
  }
`;

export const PackageList = styled.div`
  overflow-y: auto;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  justify-content: ${isMobile ? "center" : "space-between"};
  align-items: ${isMobile ? "flex-start" : "center"};
`;

export const PackageItem = styled.div`
  border-radius: 4px;
  width: ${isMobile ? "90%" : isTablet ? "45%" : "22%"};
  background-color: ${(props) => (props.completed ? "#f9f9f9" : "#ffffff")};
  cursor: pointer;
  position: relative;
  padding: ${isMobile ? "25px" : "30px"};
  border: ${({ selected }) =>
    selected ? "2px solid lightblue" : "1px solid #ddd"};
  margin: ${isMobile ? "5px" : "10px"};
  text-align: center;

  &:hover {
    background-color: #f0f0f0;
  }

  & input[type="checkbox"] {
    position: absolute;
    left: ${isMobile ? "15px" : "10px"};
    top: ${isMobile ? "15px" : "10px"};
    transform: ${isMobile ? "scale(2.5)" : "scale(1.5)"};
    cursor: pointer;
  }
  & ${PackageStatusMessage} {
    position: absolute;
    bottom: 0;
    width: 100%;
    margin-top: 0;
  }
`;

export const PackageLabelContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 10px;
`;

export const PackageText = styled.p`
  font-size: 16px;
  margin-right: 5px;
  color: grey;
`;

export const PackageLabelValue = styled.h4`
  position: relative;
  bottom: 3px;
`;
export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-item: center;
  width: ${isMobile ? "75%" : "20%"};
`;
